module.exports = __webpack_public_path__ + "static/media/rightmg.e23ae5ba.png";